import * as React from "react";
import { classNames } from "../uitk-react-utils/index.js";
import { UitkButton } from "./index.js";
export class UitkTertiaryButton extends React.Component {
  static displayName = "UitkTertiaryButton";
  render() {
    const { className, alignLabelToContent, inverse, ...props } = this.props;
    const cssClassNames = classNames(`${UitkButton.baseClassName}-tertiary`, className, {
      [`${UitkButton.baseClassName}-tertiary-align-with-content-${alignLabelToContent}`]: alignLabelToContent,
      [`${UitkButton.baseClassName}-tertiary-inverse`]: inverse
    });
    return /* @__PURE__ */ React.createElement(UitkButton, { ...props, className: cssClassNames });
  }
}
